import ApiKeys from '../ApiKeys';

const AdminApiKeys = () => {
  return <ApiKeys />;
};

export default AdminApiKeys;

